export const DragDropEnum = {
    csplDragNotUploaded:"csplDragNotUploaded",
    csplDragError:"csplDragError",
    csplDragSuccess:"csplDragSuccess"
};